import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { SimTypography } from 'components/SimTypography';
import {
	FSSAutismAssessment,
	FSSAutismScreeningSummary,
	FSSDevSkillDeficiencyScreening,
	FSSDevSkillDeficiencyScreeningSummary,
	FSSFuncBehaviorAssessment,
	FSSFuncBehaviorAssessmentSummary,
	Page
} from './components';

const AllAssessments = () => {
	const theme = useTheme();

	return (
		<Box>
			<Page>
				<Box sx={{ boxShadow: 0 }} marginTop={'25px'} marginX={0}>
					{/* START SUBHEADER */}
					<Box paddingY={'20px'}>
						<Container>
							<SimTypography
								sx={{
									textTransform: 'uppercase',
									fontWeight: 'medium'
								}}
								gutterBottom
								color={'secondary'}
								align={'left'}>
								OUR FOUNDERS' NOTE
							</SimTypography>
							<SimTypography
								sx={{
									textTransform: 'uppercase',
									fontWeight: 'medium'
								}}
								color={'secondary'}
								align={'left'}></SimTypography>
							<SimTypography
								variant='h6'
								align={'left'}
								sx={{
									fontWeight: 700,
									fontStyle: 'italic'
								}}>
								Diagnosis is perhaps the most under-rated part in a child's development journey. We as
								parents sense and appreciate it now, looking back. Our diagnostics services catalogue &
								resource library will help you get a better experience than we did.
								<block></block>
							</SimTypography>
						</Container>
					</Box>
					{/* END SUBHEADER */}
					<Box
						id='dividerFinal'
						height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
						marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
						<Box
							height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
							component={'svg'}
							preserveAspectRatio='none'
							xmlns='http://www.w3.org/2000/svg'
							x='0px'
							y='0px'
							viewBox='0 0 1920 100.1'
							sx={{
								marginBottom: -1,
								width: 1
							}}>
							<path
								fill={theme.palette.divider.dark}
								d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
						</Box>
					</Box>

					<Box
						id='ANCHOR_Diagnostics_Autism'
						// sx={{
						// 	boxShadow: 0,
						// 	backgroundImage: `linear-gradient(${alpha(theme.palette.divider.dark, 1)} 0%, ${alpha(
						// 		// theme.palette.background.default,
						// 		0
						// 	)} 100%)`
						// }}
						>
						<Grid container spacing={0}>
							<Grid item xs={12} lg={6}>
								<FSSAutismScreeningSummary />
							</Grid>
							<Grid item xs={12} lg={6}>
								<Box paddingTop={{ sx: 0, lg: 9 }}>
									<FSSAutismAssessment />
								</Box>
							</Grid>
						</Grid>
					</Box>

					<Box
						id='dividerFinal'
						height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
						marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
						<Box
							height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
							component={'svg'}
							preserveAspectRatio='none'
							xmlns='http://www.w3.org/2000/svg'
							x='0px'
							y='0px'
							viewBox='0 0 1920 100.1'
							sx={{
								marginBottom: -1,
								width: 1
							}}>
							<path
								fill={theme.palette.divider.dark}
								d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
						</Box>
					</Box>

					<Box
						id='ANCHOR_Diagnostics_FuncBehavior'
						// sx={{
						// 	boxShadow: 0,
						// 	backgroundImage: `linear-gradient(${alpha(theme.palette.divider.dark, 1)} 0%, ${alpha(
						// 		theme.palette.background.default,
						// 		0
						// 	)} 100%)`
						// }}
						>
						<Grid container spacing={0}>
							<Grid item xs={12} lg={6}>
								<FSSFuncBehaviorAssessmentSummary />
							</Grid>
							<Grid item xs={12} lg={6}>
								<Box paddingTop={{ sx: 0, lg: 6 }}>
									<FSSFuncBehaviorAssessment />
								</Box>
							</Grid>
						</Grid>
					</Box>

					<Box
						id='dividerFinal'
						height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
						marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}>
						<Box
							height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
							component={'svg'}
							preserveAspectRatio='none'
							xmlns='http://www.w3.org/2000/svg'
							x='0px'
							y='0px'
							viewBox='0 0 1920 100.1'
							sx={{
								marginBottom: -1,
								width: 1
							}}>
							<path
								// fill={theme.palette.divider.dark}
								d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
						</Box>
					</Box>

					<Box
						id='ANCHOR_Diagnostics_SkillDef'
						// sx={{
						// 	boxShadow: 0,
						// 	backgroundImage: `linear-gradient(${alpha(theme.palette.divider.dark, 1)} 0%, ${alpha(
						// 		theme.palette.background.default,
						// 		0
						// 	)} 100%)`
						// }}
						>
						<Grid container spacing={0}>
							<Grid item xs={12} lg={6}>
								<FSSDevSkillDeficiencyScreeningSummary />
							</Grid>
							<Grid item xs={12} lg={6}>
								<Box paddingTop={{ sx: 0, lg: 9 }}>
									<FSSDevSkillDeficiencyScreening />
								</Box>
							</Grid>
						</Grid>
					</Box>
				</Box>
			</Page>
		</Box>
	);
};

export default AllAssessments;
